import { render } from "./entry.vue?vue&type=template&id=aa5e28e4&scoped=true"
import script from "./entry.vue?vue&type=script&lang=js"
export * from "./entry.vue?vue&type=script&lang=js"

import "./entry.vue?vue&type=style&index=0&id=aa5e28e4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/faber-mieruca-connect/faber-mieruca-connect/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa5e28e4"]])

export default __exports__